import './styles.css';
import { createLoggerApp } from './phase1/logger-app';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector<HTMLDivElement>('#app');
  if (!root) {
    throw new Error('Root element not found');
  }
  createLoggerApp(root);
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.error('Service worker registration failed', error);
    });
  });
}
